import { seoConfig, getSiteUrl, SITE_IMAGE, SITE_NAME } from './seoConfig';

export interface JsonLd {
  '@context': string;
  '@type': string;
  [key: string]: unknown;
}

const helpFaqs: { question: string; answer: string }[] = [
  {
    question: '天天漫画是免费使用的吗？',
    answer:
      '天天漫画的基础功能完全免费，包括免费阅读大量正版漫画、基础阅读模式、社区互动等。部分独家内容和高级功能需要开通会员，但免费用户也能享受到丰富的漫画资源。',
  },
  {
    question: '如何下载天天漫画APP？',
    answer:
      '天天漫画APP下载非常简单，你可以直接访问我们的下载页面，根据你的设备选择对应的版本下载安装。我们支持Android、iOS、HarmonyOS和Windows四大平台。天天漫画下载安全无毒，请放心使用。',
  },
  {
    question: '天天漫画的正版漫画资源多吗？',
    answer:
      '天天漫画目前收录超过10万部正版漫画，涵盖日漫、国漫、韩漫等全品类，包括热血、恋爱、悬疑、搞笑、日常、异世界等各大类型。我们与数百家出版社和作者合作，每日更新上千章节。',
  },
  {
    question: '天天漫画支持离线阅读吗？',
    answer:
      '是的，天天漫画支持极速离线缓存功能。你可以在Wi-Fi环境下下载整本漫画或单个章节，下载后无需网络即可随时随地阅读。缓存功能完全免费，方便你在通勤、旅行等场景使用。',
  },
  {
    question: '如何更换设备后同步阅读进度？',
    answer:
      '天天漫画支持多端同步功能。只要使用同一个账号登录，你的阅读进度、书签、收藏列表等数据会自动同步到所有设备。支持手机、平板、电脑等多端无缝切换。',
  },
  {
    question: '天天漫画官方正版下载渠道有哪些？',
    answer:
      '天天漫画官方正版下载仅在本网站下载页面和各平台官方应用商店提供。请勿从未知第三方网站下载，以确保安全。iOS用户可在App Store搜索"天天漫画"下载，Android用户可在各大应用市场下载。',
  },
  {
    question: '天天漫画APP下载后如何更新？',
    answer:
      '天天漫画支持自动更新功能。当有新版本发布时，应用会提示你更新。你也可以在应用商店手动检查更新。我们平均每月发布一次更新，持续优化阅读体验。',
  },
  {
    question: '遇到阅读问题如何反馈？',
    answer:
      '你可以通过APP内的"设置-意见反馈"提交问题，我们的客服团队会在24小时内回复。你也可以通过官方社交媒体账号联系我们，或发送邮件至客服邮箱。',
  },
];

function webPage(path: string, title: string, description: string): JsonLd {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: title,
    description,
    url: `${getSiteUrl()}${path}`,
    inLanguage: 'zh-CN',
  };
}

export function getSchemas(path: string): JsonLd[] {
  const siteUrl = getSiteUrl();
  const seo = seoConfig[path];
  if (!seo) return [];

  if (path === '/') {
    return [
      {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: SITE_NAME,
        url: siteUrl,
        logo: SITE_IMAGE,
        description: seo.description,
      },
      {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: SITE_NAME,
        url: siteUrl,
        description: seo.description,
        inLanguage: 'zh-CN',
      },
    ];
  }

  if (path === '/download') {
    return [
      {
        '@context': 'https://schema.org',
        '@type': 'SoftwareApplication',
        name: SITE_NAME,
        applicationCategory: 'EntertainmentApplication',
        operatingSystem: 'Android, iOS, HarmonyOS, Windows',
        description: seo.description,
        url: `${siteUrl}/download`,
        offers: {
          '@type': 'Offer',
          price: '0',
          priceCurrency: 'CNY',
        },
        aggregateRating: {
          '@type': 'AggregateRating',
          ratingValue: '4.9',
          bestRating: '5',
          worstRating: '1',
        },
      },
    ];
  }

  if (path === '/reviews') {
    return [
      {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: seo.title,
        description: seo.description,
        url: `${siteUrl}${path}`,
        inLanguage: 'zh-CN',
        aggregateRating: {
          '@type': 'AggregateRating',
          ratingValue: '4.9',
          bestRating: '5',
          worstRating: '1',
        },
      },
    ];
  }

  if (path === '/about') {
    return [
      {
        '@context': 'https://schema.org',
        '@type': 'AboutPage',
        name: seo.title,
        description: seo.description,
        url: `${siteUrl}${path}`,
        inLanguage: 'zh-CN',
        mainEntity: {
          '@type': 'Organization',
          name: SITE_NAME,
          url: siteUrl,
          logo: SITE_IMAGE,
        },
      },
    ];
  }

  if (path === '/help') {
    return [
      {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: helpFaqs.map((f) => ({
          '@type': 'Question',
          name: f.question,
          acceptedAnswer: {
            '@type': 'Answer',
            text: f.answer,
          },
        })),
      },
    ];
  }

  return [webPage(path, seo.title, seo.description)];
}